import { PAYMENT_METHOD_HASH_TYPE_STRIPE } from '../../constants';

export const stripePaymentMethodHashPayloadFactory = (
  paymentMethodId: string,
): object => ({
  type: PAYMENT_METHOD_HASH_TYPE_STRIPE,
  stripe_payment_method: {
    token: paymentMethodId,
  },
});
